/* Macro targets that add up to the calorie target (4 kcal/g protein and
 * carbs, 9 kcal/g fat). One macro is always the balancing one: editing
 * protein or carbs (or the calories) moves fats, editing fats moves carbs. */

export const KCAL_PER_G = { protein: 4, carbs: 4, fats: 9 };

const whole = v => (Number.isFinite(v) && v > 0 ? Math.round(v) : 0);

export function macroKcal(m) {
  return whole(m.protein) * 4 + whole(m.carbs) * 4 + whole(m.fats) * 9;
}

/**
 * The new targets after one field changes.
 * @param {number} kcal current calorie target
 * @param {{protein, carbs, fats}} macros current macros (g)
 * @param {'calories'|'protein'|'carbs'|'fats'} field what was edited
 * @param {number} value its new value
 * @returns {{calorieTarget:number, macros:{protein, carbs, fats}}} the
 *   balancing macro never goes below 0; then the sum can't reach the target.
 */
export function balanceMacros(kcal, macros, field, value) {
  let target = whole(kcal);
  const m = { protein: whole(macros.protein), carbs: whole(macros.carbs), fats: whole(macros.fats) };
  if (field === 'calories') target = whole(value);
  else m[field] = whole(value);
  if (field === 'fats') m.carbs = whole((target - m.protein * 4 - m.fats * 9) / 4);
  else m.fats = whole((target - m.protein * 4 - m.carbs * 4) / 9);
  return { calorieTarget: target, macros: m };
}
